const jquery = require('jquery');
const googleMap = require('./gmap');
const baseURL = window.BASE_URL;

jquery(document).ready(($) => {
    let searchLocation = false;
    let searchResults = [];
    let map = false;
    let infoWindow = false;
    let markers = [];
    let markerCluster = false;

    googleMap.ready(() => {

        if (!document.getElementById('search_map_view')) {
            // Not in search page
            return false;
        }

        let center = false;
        if (searchLocation) {
            center = new google.maps.LatLng(searchLocation.lat, searchLocation.lng);
        } else {
            center = new google.maps.LatLng(59.3252943, 18.0302436);
        }
        infoWindow = new google.maps.InfoWindow;
        map = new google.maps.Map(document.getElementById('search_map_view'), {
            center: center,
            zoom: 12,
            maxZoom: 13
        });

        updateMap(searchResults, searchLocation);
    });

    $('body').on('search_results',function (e, result, fromLocation) {
        searchLocation = fromLocation;
        searchResults = result.search;
        updateMap(searchResults, searchLocation);
    });

    function cleanMarkers () {
        if (markerCluster) {
            markerCluster.clearMarkers();
        }
        for (let i = 0; i < markers.length; i++) {

            markers[i].setMap(null);
        }
        markers = [];
        markerCluster = false;
    }

    function updateMap(searchResults, searchLocation) {
        if (!map || !infoWindow || !searchResults) return;

        cleanMarkers();
        if (searchLocation) {
            const center = new google.maps.LatLng(searchLocation.lat, searchLocation.lng);
            map.setCenter(center);
        }

        $.each(searchResults, function (key,val) {
            var num_rated = val.num_rated ? '(' + val.num_rated + ')' : '';
            var link_profile = val.borrower ? val.borrower : val.ownerLink;
            var name = val.name ? val.name : val.first_name;
            var infoMaker = '<div class="result-marker">' +
                '<div class="wrap-avatar">' +
                '<img class="marker-avatar" src="' + val.avatar +'"/>' +
                '</div>' +
                '<div class="wrap-info">' +
                '<a class="marker-name" href="' + link_profile + '">' + name + '</a>' +
                '<p class="marker-membership">' + val.membership + '</p>' +
                '<p class="marker-distance"><span class="icon icon-pin"></span> &nbsp;'+ val.distance +'</p>' +
                '<div class="wrap-rating">' +
                '<i class="fa fa-star" aria-hidden="true" style="color:'+ getStarColor(1, val.stars) +'"></i>' +
                '<i class="fa fa-star" aria-hidden="true" style="color:'+ getStarColor(2, val.stars) +'"></i>' +
                '<i class="fa fa-star" aria-hidden="true" style="color:'+ getStarColor(3, val.stars) +'"></i>' +
                '<i class="fa fa-star" aria-hidden="true" style="color:'+ getStarColor(4, val.stars) +'"></i>' +
                '<i class="fa fa-star" aria-hidden="true" style="color:'+ getStarColor(5, val.stars) +'"></i>' +
                '<span>' + num_rated + '</span>' +
                '</div>' +
                '</div>' +
                '</div>';

            const point = new google.maps.LatLng(parseFloat(val.location_lat), parseFloat(val.location_lng));
            const marker = new google.maps.Marker({
                map: map,
                position: point,
                // label: 'A'
            });
            marker.addListener('click', function() {
                infoWindow.setContent(infoMaker);
                infoWindow.open(map, marker);
            });
            markers.push(marker);
        });
        markerCluster = new MarkerClusterer(map, markers,
            {imagePath: baseURL + '/images/m'});
        google.maps.event.addListener(markerCluster, 'clusterclick', function(cluster) {

            // Convert lat/long from cluster object to a usable MVCObject
            var info = new google.maps.MVCObject;
            info.set('position', cluster.center_);

            //----
            //Get markers
            var markers = cluster.getMarkers();

            let infoMaker = "";
            let listMarkers = [];
            let checkMarkerExist = [];
            //Get all the titles
            for(var i = 0; i < markers.length; i++) {
                let markerGroupLat = markers[i].position.lat();
                let markerGroupLng = markers[i].position.lng();
                for(let j = 0; j < searchResults.length; j++) {
                    let markerResultLat = parseFloat(searchResults[j].location_lat);
                    let markerResultLng = parseFloat(searchResults[j].location_lng);
                    if(checkMarkerExist.includes(searchResults[j].id)) {
                        continue;
                    }
                    if(markerGroupLat.toFixed(6) === markerResultLat.toFixed(6) &&
                        markerGroupLng.toFixed(6) === markerResultLng.toFixed(6)) {
                        listMarkers.push(searchResults[j]);
                        checkMarkerExist.push(searchResults[j].id)
                    }
                }
            }
            //----

            $.each(listMarkers, function (key, val) {
                var num_rated = val.num_rated ? '(' + val.num_rated + ')' : '';
                var link_profile = val.borrower ? val.borrower : val.ownerLink;
                var name = val.name ? val.name : val.first_name;
                infoMaker += '<div class="result-marker">' +
                    '<div class="wrap-avatar">' +
                    '<a href="' + link_profile + '">' +
                    '<img class="marker-avatar" src="' + val.avatar +'"/>' +
                    '</a>' +
                    '</div>' +
                    '<div class="wrap-info">' +
                    '<a class="marker-name" href="' + link_profile + '">' + name + '</a>' +
                    '<p class="marker-membership">' + val.membership + '</p>' +
                    '<p class="marker-distance"><span class="icon icon-pin"></span> &nbsp;'+ val.distance +'</p>' +
                    '<div class="wrap-rating">' +
                    '<i class="fa fa-star" aria-hidden="true" style="color:'+ getStarColor(1, val.stars) +'"></i>' +
                    '<i class="fa fa-star" aria-hidden="true" style="color:'+ getStarColor(2, val.stars) +'"></i>' +
                    '<i class="fa fa-star" aria-hidden="true" style="color:'+ getStarColor(3, val.stars) +'"></i>' +
                    '<i class="fa fa-star" aria-hidden="true" style="color:'+ getStarColor(4, val.stars) +'"></i>' +
                    '<i class="fa fa-star" aria-hidden="true" style="color:'+ getStarColor(5, val.stars) +'"></i>' +
                    '<span>' + num_rated + '</span>' +
                    '</div>' +
                    '</div>' +
                    '<hr>' +
                    '</div>';
            });

            var infowindow = new google.maps.InfoWindow();
            infowindow.close();
            infowindow.setContent('<div class="list-result-marker">'+ infoMaker + '</div>'); //set infowindow content to titles
            infowindow.open(map, info);
        });
    }

    function getStarColor(starPosition, markerStar) {
        if(markerStar) {
            return starPosition <= markerStar ? "#EDB867" : "#d2d2d2";
        }
        return "#d2d2d2";
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/search.js